// React root error-handling infrastructure, allowed to wire the SDK handlers directly.
// oxlint-disable-next-line no-restricted-imports
import * as Sentry from '@sentry/react';
import { type RootOptions } from 'react-dom/client';
import { createReactErrorHandler } from '@/helpers/errors/createReactErrorHandler';
import { router } from '@/router';
import { isLocalDevelopmentEnv, isDevelopmentEnv } from '@/utils/utils';

export const rootOptions: RootOptions = {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: createReactErrorHandler(router),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: createReactErrorHandler(router, (error) => {
    if (isLocalDevelopmentEnv || isDevelopmentEnv) {
      console.error('Error Boundary:', error); // oxlint-disable-line no-console
    }
  }),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
};
